import { Plus } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "react-router";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { findNavItemByPath } from "../navigation/navConfig";
import { GlobalSearch, GlobalSearchTrigger } from "../search/GlobalSearch";
import { WorkspaceSelector } from "./WorkspaceSelector";
import { NotificationsMenu } from "./NotificationsMenu";
import { CopilotDrawer } from "../ai/CopilotDrawer";

/**
 * Gravun top bar: contextual page title, global search, quick create,
 * workspace selector and notifications. Kept deliberately quiet, a thin
 * white bar with a subtle bottom border.
 */
export const GravunTopbar = () => {
  const location = useLocation();
  const [searchOpen, setSearchOpen] = useState(false);

  const navItem = findNavItemByPath(location.pathname);

  return (
    <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center gap-3 border-b border-border bg-card/95 px-5 backdrop-blur supports-[backdrop-filter]:bg-card/80">
      <h1 className="min-w-0 truncate text-[15px] font-semibold tracking-tight text-foreground">
        {navItem?.label ?? ""}
      </h1>

      <div className="flex flex-1 justify-center px-4">
        <GlobalSearchTrigger onOpen={() => setSearchOpen(true)} />
      </div>

      <div className="flex items-center gap-2">
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <Button
              size="sm"
              className="h-8 gap-1.5 rounded-md px-2.5 text-[13px] font-medium shadow-none"
            >
              <Plus className="size-4" />
              <span className="hidden md:inline">New</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-44 rounded-lg">
            <DropdownMenuItem asChild>
              <Link to="/contacts/create">Contact</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/companies/create">Company</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to="/deals/create">Deal</Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>

        <WorkspaceSelector />

        <CopilotDrawer />
        <NotificationsMenu />
      </div>

      <GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} />
    </header>
  );
};
